module.exports = {
  google: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_KEY || "",
    SECRET: process.env.REACT_APP_GOOGLE_SECRET_KEY || "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_CLIENT_ID || "",
    SECRET: process.env.REACT_APP_FACEBOOK_CLIENT_SECRET || "",
  },
  stripe: {
    PUBLIC_KEY: process.env.REACT_APP_STRIPE_KEY || "",
    SECRET_KEY: process.env.REACT_APP_STRIPE_SECRET || "",
  },
  portal: {
    customerUrl: process.env.REACT_APP_CUSTOMER_URL || "devapp.oflrewards.com",
    adminUrl: process.env.REACT_APP_ADMIN_URL || "devadmin.oflrewards.com",
  },
};
